import { TreeNode } from '@components'

import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { defaultStaleTime } from '../../../config/queryClient'
import { QueryKeys } from '../../../enums/queryKeys'
import { ROOT_FOLDER_ID } from '../constants/rootFolderId'
import { fetchFolders } from '../query-api'
import { DmsFolderNode } from '../types'
import { useDmsUserRole } from './useDmsUserRole'

const toFolderTree = (data: DmsFolderNode[]): TreeNode[] =>
  data.reduce<TreeNode[]>((acc, folder) => {
    if (folder.id !== ROOT_FOLDER_ID) {
      acc.push({
        id: folder.id,
        name: folder.name,
        parentId: folder.parentFolderId,
        childIds: folder.childrenIds,
      })
    }
    return acc
  }, [])

export const useFetchFolderTree = () => {
  const { organization } = useUserOrganization()
  const { isBoWithoutCpa, isCpaExpertMode, isLoading: isRoleLoading } = useDmsUserRole()
  const isCpa = isBoWithoutCpa || isCpaExpertMode

  const { data, isLoading, isFetching } = useQuery<DmsFolderNode[], Error, TreeNode[]>(
    [QueryKeys.DmsFolders, organization?.id, isCpa],
    () => fetchFolders(organization?.id as string, isCpa),
    {
      enabled: !!organization?.id && !isRoleLoading,
      staleTime: defaultStaleTime,
      select: toFolderTree,
    },
  )

  return {
    tree: data,
    isLoading: isRoleLoading || isLoading,
    isFetching,
    isEmpty: !isRoleLoading && !isLoading && (!data || data.length === 0),
  }
}
